export const UNLIMITED_ADVANCE_CHAPTERS_COUNT = -1;
